'use strict'

module.exports = [
  'indeterminate'
]
